export var CURRENT_PAGE_ENTITY_VERSION = 'PageContext102';
export var CURRENT_USER_ENTITY_VERSION = 'UserContext101';
export var CURRENT_EXPERIMENT_ENTITY_VERSION = 'Experiment100';
export var CURRENT_TRACING_ENTITY_VERSION = 'TracingContext100';
